import { Response } from '@angular/http';
import * as Q from 'q';
import { isInArray } from '../../util/is-in-array';
import { isVersionableEntity } from '../../util/utils';
import { HTTP_METHODS } from './index';
import { OperationResult } from './operation-result';
import { ResultHandlerAction, SyncUpResponseHandlerActionOptions } from './result-handler-action';

export class ResultHandler {

    constructor(
        protected result: OperationResult,
        protected appFacade
    ) {

    }

    handle(): Promise<any> {

        const actions = this.getActions();

        return actions.map(action => {
            return () => {

                if (!action) {
                    console.warn('undefined action found');
                    return Promise.resolve();
                }

                return action.handle();
            };
        }).reduce<any>(Q.when, Q());
    }

    getActions(): Array<ResultHandlerAction> {

        let results = [];

        try {
            results.push(this.result.getPrimaryResult());
        } catch (e) {
            console.warn(e);
        }

        try {
            results = results.concat(this.result.getSubResourceResults());
        } catch (e) {
            console.warn(e);
        }

        return results
            .filter(result => !!result)
            .map(result => this.resultToAction(result));
    }

    protected getAction(result: OperationResult, options: SyncUpResponseHandlerActionOptions): ResultHandlerAction {
        return new ResultHandlerAction(result, this.appFacade).setOptions(options);
    }

    resultToAction(result: OperationResult): ResultHandlerAction {

        const item = result.item;

        let response: Response | Error;

        if (result.response instanceof Error) {
            return this.getAction(result, {
                shouldDeleteChangeQItem: true
            });
        } else if (!result || !result.response) {
            console.warn('undefined response??');
            return this.getAction(result, {
                shouldDeleteChangeQItem: true
            });
        }

        response = result.response;

        // see https://git.ironcode.io/vas/vas-mobile/issues/575 for the spec
        switch (true) {
            case isInArray(response.status, [500, 403]): {
                return this.getAction(result, {
                    shouldNotifyUser: true
                });
            }
            case response.status === 404: {

                // this case handles when we do a patch on a ref list and the referenced object is not visible to the
                // user. In this case we should ignore the 404
                if ((response.json() || {}).message === 'Entity not found while updating reference list') {
                    return this.getAction(result, {
                        shouldDeleteChangeQItem: true
                    });
                }

                return this.getAction(result, {
                    shouldDeleteChangeQItem: true,
                    shouldDeleteLocalItem: true
                });
            }
            case response.status === 405: {
                return this.getAction(result, {
                    shouldDeleteChangeQItem: true
                });
            }
            case response.status === 409: {

                const body = response.json();

                if (body && (body.message || '').match(/^Wrong version/)) {
                    return this.getAction(result, {
                        shouldAutoResolveVersionConflict: true
                    });
                } else {
                    return this.getAction(result, {
                        shouldNotifyUser: true
                    });
                }
            }
            case response.ok && (item.method === HTTP_METHODS.POST || item.method === HTTP_METHODS.PATCH || item.method === HTTP_METHODS.REFRESH): {
                return this.getAction(result, {
                    shouldDeleteChangeQItem: true,
                    shouldRefreshItem: item.entity === 'job' && item.method === HTTP_METHODS.POST,
                    shouldBumpVersion: item.method === HTTP_METHODS.PATCH && isVersionableEntity(item.entity)
                });
            }
            case response.ok && item.method === 'DELETE': {
                return this.getAction(result, {
                    shouldDeleteChangeQItem: true,
                    shouldDeleteLocalItem: true
                });
            }
            default : {
                return this.getAction(result, {
                    shouldNotifyUser: true
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/result-handler.ts